import { Link, NavLink, Outlet } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { AppLayout } from "../app-layout";
import { AppHeader } from "../app-header";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "slices/user";


const dashboardLinks = [
  {
    to: ROUTES.PROJECT,
    label: "PROJECTS",
    image1: "/assets/images/icons/projects-icon-1.svg",
    image2: "/assets/images/icons/projects-icon-2.svg",
  },
  {
    to: ROUTES.ACTIVITIES,
    label: "ACTIVITIES",
    image1: "/assets/images/icons/activities-icon-1.svg",
    image2: "/assets/images/icons/activities-icon-2.svg",
  },
  {
    to: ROUTES.LIMITS,
    label: "LIMITS",
    image1: "/assets/images/icons/limits-icon-1.svg",
    image2: "/assets/images/icons/limits-icon-2.svg",
  },
  {
    to: ROUTES.ACCOUNT_SETTINGS,
    label: "ACCOUNT",
    image1: "/assets/images/icons/account-icon-1.svg",
    image2: "/assets/images/icons/account-icon-2.svg",
  },
];

const AppDashboard = () => {

  return (
    <AppLayout>
      <div className="content outer-div">
        <div className="row mx-0">
          <div className="col-auto px-0">
            <aside>
              <Link to={"/" + ROUTES.PROJECT}><img src="/assets/images/cloud-logo-white.svg" alt=""
                className="img-fluid d-block mb-5 mx-auto aside-logo" />
              </Link>
              <div className="aside-nav">
                {dashboardLinks.map(({ to, label, image1, image2 }) => (
                  <NavLink
                    key={to}
                    to={"/" + to}
                    className={({ isActive }) =>
                      isActive ? "aside-nav-link active" : "aside-nav-link"
                    }
                  >
                    <span className="nav-icon">
                      <img src={image1} alt="" className="img-fluid" />
                      <img src={image2} alt="" className="img-fluid" />
                    </span>
                    <span className="link-text">{label}</span>
                  </NavLink>
                ))}

              </div>
            </aside >
          </div>
          <div className="col">
            <div className="content-block px-3">
              <AppHeader />


              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  )
}

export default AppDashboard;